export const normalizePromptResponse = prompt => ({
    id: prompt.id,
    name: prompt.name,
    friendlyName: prompt.friendly_name,
    description: prompt.description,
    createdAt: prompt.created_at,
    isActive: prompt.is_active,
    userId: prompt.user_id,
    prompt: prompt.prompt,
})

export const normalizePromptsResponse = response => response.map(normalizePromptResponse)
